/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  share.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:33
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter,assignParams} from "./index";
import {ShopGoodsImgListDto, ShopGoodsTagListDto} from "@/api/shoppingMall";
import {PackageListDto, RuleListDto} from "@/api/buyCar";
import {axiosShareAPIUrl} from "@/api/shareAxios";

export class ShareGoodsListDto {
    /* 商品编号 */
    goodsId?: string;
    /* 商品编码 */
    goodsCode?: string;
    /* 商品名称 */
    goodsName?: string;
    /* 商品主图 */
    goodsMainImage?: string;
    /* 商品价格 */
    goodsPrice?: string;
    /* 商品套餐数量 */
    packageCount?: number;
}

/**
 * 获取H5全部商品列表
 * @param parameter
 */
export function getH5GoodsList(parameter: Parameter = {}) {
    return axiosShareAPIUrl<Ajax.Response<Ajax.ListData<ShareGoodsListDto>>>({
        url: "/cykjenterprise/html5Share/getH5GoodsList",
        method: "get",
        params: parameter,
    });
}

export class ShareGoodsDetailDto {
    goodsId?: string;
    goodsName?: string;
    goodsCode?: string;
    categoryId?: string;
    categoryName?: string;
    brandId?: string;
    brandName?: string;
    videoUrl?: string;
    descriptionUrl?: string;
    descriptionContext?: string;
    goodsPrice?: number;
    packageCount?: string;
    goodsMainImage?: string;
    isMultiSpec?: boolean;
    // 	价格显示类型	分享商品页面价格显示类别
    //     (0:不显示价格，1:市场价)
    priceShowType?: number;
    goodsImageList?: ShopGoodsImgListDto[];
    goodsTagList?: ShopGoodsTagListDto[];
}

/**
 * 获取H5商品详情
 * @param parameter
 */
export function getH5GoodsInfo(parameter: Parameter = {}) {
    return axiosShareAPIUrl<Ajax.Response<ShareGoodsDetailDto>>({
        url: "/cykjenterprise/html5Share/getH5GoodsInfo",
        method: "post",
        data: parameter,
    });
}

/**
 * 获取H5商品规格列表
 * @param parameter
 */
export function getH5GoodsSpecificationList(parameter: Parameter = {}) {
    return axiosShareAPIUrl<Ajax.Response<{ goodsSpecificationList?: RuleListDto[], packageList?: PackageListDto[] }>>({
        url: "/cykjenterprise/html5Share/getH5GoodsSpecificationList",
        method: "get",
        params: parameter,
    });
}

// 获取小程序分享二维码
export function getShareQrCode (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: '/cykjoperation/ccx/getQrCode',
        method: 'post',
        data: { ...params, ...assignParams() },
        extraParams: { showLoading: false }
    })
}
